import {
	APPOINTMENTS_FETCH_SUCCESS,
	APPOINTMENTS_FETCH_ERROR,
	OTHER_EVENTS_FETCH_SUCCESS,
	EVENTS_FETCH_SUCCESS,
	EVENTS_FETCH_ERROR,
	APPOINTMENT_ADDED,
	APPOINTMENT_UPDATED,
	APPOINTMENT_DELETED,
	TODOS_FETCH_SUCCESS
} from 'Store/reducers/AppointmentsReducer';
import AppService from 'App/legacy/AppService';
import StandardIntegrationData from 'Resources/StandardIntegrationData';
import { parseFilters } from 'App/helpers/filterHelper';
import { getConfig } from 'App/helpers/filterHelperInstances';
export const otherEventsFetchSuccess = value => ({ type: OTHER_EVENTS_FETCH_SUCCESS, value });
export const eventsFetchSuccess = value => ({ type: EVENTS_FETCH_SUCCESS, value });
export const eventsFetchError = value => ({ type: EVENTS_FETCH_ERROR, value });
export const appointmentFetchSuccess = value => ({ type: APPOINTMENTS_FETCH_SUCCESS, value });
export const appointmentFetchError = value => ({ type: APPOINTMENTS_FETCH_ERROR, value });
export const appointmentAdded = value => ({ type: APPOINTMENT_ADDED, value });
export const appointmentUpdated = value => ({ type: APPOINTMENT_UPDATED, value });
export const appointmentDeleted = value => ({ type: APPOINTMENT_DELETED, value });
export const todosFetchSuccess = value => ({ type: TODOS_FETCH_SUCCESS, value });

export const getAppointments = (date, activeFilters = {}) => {
	return dispatch => {
		/*
			Fetch appointment for current month, the previous and next.
			Then we should have appointments that for example have a startDate prev month but ends in the current
		*/
		const customerId = AppService.getCustomerId();
		const filters = parseFilters(activeFilters, 'appointment', null, null, { getConfig });

		filters.addFilter(
			Tools.Appointment.attr.date,
			filters.comparisonTypes.GreaterThanEquals,
			moment(date).add(-1, 'month').startOf('month').startOf('week')
		);
		filters.addFilter(
			Tools.Appointment.attr.date,
			filters.comparisonTypes.LessThanEquals,
			moment(date).add(1, 'month').endOf('month').endOf('week')
		);

		return Tools.Appointment.customer(customerId)
			.find(filters.build())
			.then(res => {
				dispatch(appointmentFetchSuccess(res.data));
			})
			.catch(e => {
				dispatch(appointmentFetchError(e.message));
			});
	};
};

export const getEvents = (date, userIds) => {
	return dispatch => {
		const calendarIntegrations = AppService.getCalendarIntegrations();
		if (calendarIntegrations.length === 0) {
			return;
		}

		const [integration] = calendarIntegrations;
		const currentUserId = AppService.getSelf().id;
		// userIds comes straight from the user filter, which uses 'self' for the logged in user
		const resolvedUserIds = (userIds ?? [])
			.map(userId => (userId === 'self' ? currentUserId : Number(userId)))
			.filter((userId, index, ids) => Number.isInteger(userId) && userId > 0 && ids.indexOf(userId) === index);

		return StandardIntegrationData.run({
			data: {
				startDateTime: moment.utc(date).add(-1, 'month').startOf('month').startOf('week').format(),
				endDateTime: moment.utc(date).add(1, 'month').endOf('month').endOf('week').format()
			},
			userIds: resolvedUserIds,
			type: 'events',
			integrationId: integration.id
		})
			.then(res => {
				const eventMapper = event => ({
					...event,
					date: new Date(event.startDateTime),
					endDate: new Date(event.endDateTime),
					isEvent: true
				});

				const events =
					!resolvedUserIds.length || resolvedUserIds.indexOf(currentUserId) >= 0
						? (res.data.events ?? []).map(eventMapper)
						: [];

				let otherUsers = [];
				if (res.data.otherUsers) {
					for (const events of Object.values(res.data.otherUsers)) {
						otherUsers = otherUsers.concat(events.map(eventMapper));
					}
				}

				dispatch(eventsFetchSuccess(events));
				dispatch(otherEventsFetchSuccess(otherUsers));
			})
			.catch(e => {
				dispatch(eventsFetchError(e.message));
			});
	};
};

export const addAppointment = appointment => {
	return dispatch => {
		dispatch(appointmentAdded(appointment));
	};
};

export const updateAppointment = appointment => {
	return dispatch => {
		dispatch(appointmentUpdated(appointment));
	};
};

export const deleteAppointment = appointment => {
	return dispatch => {
		dispatch(appointmentDeleted(appointment));
	};
};

const DEFAULT_ACTIVITY_DURATION_MINUTES = 30;

export const getTodos = (date, activeFilters = {}) => {
	return async dispatch => {
		const todoTypes = AppService.getTodoTypes();
		if (!todoTypes?.TODO?.id || !todoTypes?.PHONE_CALL?.id) {
			dispatch(todosFetchSuccess([]));
			return;
		}

		const customerId = AppService.getCustomerId();
		const filters = parseFilters(activeFilters, 'activity', null, null, { getConfig });

		filters.addFilter(
			Tools.Activity.attr.date,
			filters.comparisonTypes.GreaterThanEquals,
			moment(date).add(-1, 'month').startOf('month').startOf('week')
		);
		filters.addFilter(
			Tools.Activity.attr.date,
			filters.comparisonTypes.LessThanEquals,
			moment(date).add(1, 'month').endOf('month').endOf('week')
		);
		filters.addFilter(Tools.Activity.attr.activityType.attr.id, filters.comparisonTypes.Equals, [
			todoTypes.TODO.id,
			todoTypes.PHONE_CALL.id
		]);
		filters.addFilter(Tools.Activity.attr.closeDate, filters.comparisonTypes.Equals, null);

		try {
			const res = await Tools.Activity.customer(customerId).find(filters.build());
			const todos = res.data.map(activity => {
				const hasTime = !!activity.time;
				const activityDate = hasTime
					? moment(activity.date).toDate()
					: moment(activity.date).startOf('day').toDate();
				const endDate = moment(activityDate).add(DEFAULT_ACTIVITY_DURATION_MINUTES, 'minutes').toDate();

				const calendarItemType = activity.activityType?.id === todoTypes.PHONE_CALL.id ? 'phonecall' : 'todo';

				return {
					...activity,
					date: activityDate,
					endDate,
					calendarItemType,
					isAllDay: !hasTime
				};
			});
			dispatch(todosFetchSuccess(todos));
		} catch (e) {
			console.error('Failed to fetch todos for calendar', e);
			dispatch(todosFetchSuccess([]));
		}
	};
};
